<!-- ================科学艺术馆-恒岳科创会线下活动====================-->
<template>
    <div class="technology-offline-page">
        <home-head />
        <div class="technology-offline-body">
            <div class="technology-offline-inner">
                <div class="technology-offline-header">
                    <div class="technology-offline-title-box">
                        <div class="technology-offline-title">恒岳科创会</div>
                        <div class="technology-offline-subtitle">科创类主题班会资源</div>
                    </div>
                    <div class="technology-offline-actions">
                        <!-- <input class="search-input" type="text" placeholder="请输入关键词" v-model="searchKeyword" />
                        <div class="search-btn" @click="handleSearch">搜索</div> -->
                        <div class="back-btn" @click="goBack">
                            <span class="back-arrow">←</span>
                            <span>返回</span>
                        </div>
                    </div>
                </div>

                <div class="technology-offline-cards">
                    <div class="technology-offline-card cursor" v-for="(item, index) in categoryList" :key="index" @click="handleCategory(item)">
                        <div class="technology-offline-card-box">
                            <div class="technology-offline-card-main">
                                <div class="technology-offline-card-month">{{ item.itemMonth }}</div>
                                <div class="technology-offline-card-theme">{{ item.itemName }}</div>
                            </div>
                            <div class="technology-offline-card-desc">{{ item.itemDesc }}</div>
                            <div class="technology-offline-card-desc">&nbsp;</div>
                            <div class="technology-offline-card-desc">&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {listItem} from "@/api/admin/item"
import homeHead from "@/components/common/homeHead.vue";
export default {
    components: {homeHead},
    name: "technologyOffline",
    data() {
        return {
            searchKeyword: "",
            categoryList: [],
            queryItemForm:{
                itemType:'2',
                museumKey:'2',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryItemList();
    },
    mounted() {},
    methods: {
        /* ===============数据查询===================== */
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code===1){
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        /* ===============跳转===================== */
        handleSearch(){
            this.$message.success("搜索：" + this.searchKeyword)
        },
        goBack(){
            this.$router.push("/museum/technology")
        },
        handleCategory(item){
            this.$router.push({
                path: "/museum/technology/offlinePage",
                query: { item: item.itemId },
            });
        }
    }
}
</script>

<style scoped>
.technology-offline-page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.technology-offline-body{
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}
.technology-offline-inner{
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.technology-offline-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}
.technology-offline-title-box{
    display: flex;
    flex-direction: column;
}
.technology-offline-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}
.technology-offline-subtitle{
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}
.technology-offline-actions{
    display: flex;
    align-items: center;
    gap: 12px;
}
.search-input{
    width: 180px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 13px;
    font-family: sans-serif;
    box-sizing: border-box;
}
.search-input:focus{
    border-color: #b22222;
}
.search-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 18px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 13px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}
.search-btn:hover{
    background-color: #b22222;
    color: #ffffff;
}
.back-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 26px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}
.back-btn:hover{
    background-color: #9a1b1b;
}
.back-arrow{
    margin-right: 6px;
    font-size: 16px;
}
.technology-offline-cards{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 20px;
    box-sizing: border-box;
}

.technology-offline-card{
    min-width: 0;
    min-height: 0;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 3px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.technology-offline-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.technology-offline-card-box{
    width: 100%;
    height: 100%;
    border: 1px solid #e99d42;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.technology-offline-card-main{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.technology-offline-card-month{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 6px;
}
.technology-offline-card-theme{
    font-size: 18px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
}
.technology-offline-card-desc{
    font-size: 12px;
    color: #e99d42!important;
    font-family: sans-serif;
    text-align: center;
    line-height: 2.4;
}
@media (max-width: 1280px) {
    .technology-offline-inner { padding: 0 20px; }
    .technology-offline-cards { gap: 16px; margin-bottom: 30px; }
    .technology-offline-card { padding: 3px 3px; }
    .technology-offline-card-month { font-size: 18px; }
    .technology-offline-card-theme { font-size: 16px; }
    .technology-offline-card-desc { font-size: 11px; }
}
@media (max-width: 1024px) {
    .technology-offline-title { font-size: 16px; }
    .technology-offline-subtitle { font-size: 12px; }
    .search-input { width: 140px; }
    .back-btn { padding: 0 18px; font-size: 13px; }
    .technology-offline-cards { gap: 12px; margin-bottom: 20px; }
    .technology-offline-card { padding: 3px 3px; }
    .technology-offline-card-month { font-size: 14px; }
    .technology-offline-card-theme { font-size: 13px; }
    .technology-offline-card-desc { font-size: 10px; }
}
</style>
